let params = {
    privacy: {
        view: 'unlisted',
        comments: 'contacts',
        download: false,
        add: false,
    },
    embed: {
        buttons: {
            like: false,
            share: false,
            watchlater: false,
        },
    },
    logos: {
        vimeo: false,
    },
    title: {
        name: 'hide',
        owner: 'hide',
        portrait: 'hide'
    },
};
import EventBus from "@/utils/event-bus";

const CLIENT_ID = '2eeeccc43be477e71b0c20a616b7e873a21f3415';
const CLIENT_SECRET = 'nP6TCuPMH5zShDX7z9Na3hLUimKWep/rdCJb6S7TQ/ydIxx5akNT+fa2yXGue93qgVTqcZJJrwbs0u/lAOn/Sclt0Uorr8H6yLHedF8uyT0y0+2HdLpSCZryQSzoBvGP';
const ACCESS_TOKEN = '05102ed085e5d939783048b22ba266eb';

class vimeoPlugin {
    client = null;
    defaultParams = null;

    isOnError = false;
    init(defaultParams=null) {
        var Vimeo = require('vimeo').Vimeo;
        var client = new Vimeo(CLIENT_ID, CLIENT_SECRET, ACCESS_TOKEN);
        this.client = client;
        if(defaultParams) {
            this.defaultParams = defaultParams;
        }
    }

    runUpload(file, vimeoKey='') {
        if(!vimeoKey) {
            return this.upload(file);
        }else{
            let videoUri = `/videos/${vimeoKey}`;
            return this.replace(file, videoUri);
        }
    }

    upload(file,) {
        let defaultParams = this.defaultParams;
        defaultParams.name = file.name;
        return new Promise((resolve, reject) => {
            this.client.upload(
                file,
                defaultParams,
                function (uri) {
                    console.log('File upload completed. Your Vimeo URI is:', uri)
                    resolve(uri);
                },
                function (bytesUploaded, bytesTotal) {
                    // var percentage = (bytesUploaded / bytesTotal * 100).toFixed(2)
                    var percentage = Math.round(bytesUploaded / bytesTotal * 100)
                    console.log(bytesUploaded, bytesTotal, percentage + '%')
                    EventBus.$emit('changeLoading', true, `${percentage}%`)
                },
                function (error) {
                    console.log('Failed because: ' + error)
                    reject(error);
                }
            )
        })
    }

    replace(file, videoUri) {
        console.log(file)
        console.log(videoUri)
        let defaultParams = this.defaultParams;
        console.log()
        defaultParams.name = file.name;
        this.isOnError = false;
        let $this = this;
        return new Promise((resolve, reject) => {
            this.client.replace(
                file,
                videoUri,
                defaultParams,
                function (uri) {
                    console.log('File upload completed. Your Vimeo URI is:', uri)
                    if($this.isOnError) {
                        resolve(uri);
                    }else {
                        $this.upload(file).then(res => {
                            resolve(res);
                        })
                    }
                },
                function (bytesUploaded, bytesTotal) {
                    // var percentage = (bytesUploaded / bytesTotal * 100).toFixed(2)
                    if($this.isOnError) {
                        var percentage = Math.round(bytesUploaded / bytesTotal * 100)
                        console.log(bytesUploaded, bytesTotal, percentage + '%')
                        EventBus.$emit('changeLoading', true, `${percentage}%`)
                    }
                },
                function (error) {
                    console.log('Failed because: ' + error)
                    $this.isOnError = true;
                    reject(error);
                }
            )
        })
    }
}

export default vimeoPlugin;
